import { useTranslation } from "react-i18next";

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-4 d-flex justify-content-center align-items-center">
      <h2>{t("page-not-found")}</h2>
    </div>
  );
};

export default PageNotFound;
